var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
    'dp-control-group': true,
    'dp-control-group--stretch': _vm.stretch,
    'dp-control-group--spread': _vm.spread,
    'dp-control-group--inline': _vm.inline,
    'dp-control-group--spaced': _vm.spaced,
    'dp-control-group--centered': _vm.centered,
    'dp-control-group--left-aligned': _vm.leftAligned,
    'dp-control-group--right-aligned': _vm.rightAligned,
    'dp-control-group--top-aligned': _vm.topAligned,
    'dp-control-group--vertical': _vm.vertical,
    'dp-control-group--fit-text': _vm.fitText,
  }},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }